import React from "react";
import { useNavigate } from "react-router-dom";
import { FaMapMarkerAlt, FaClock, FaEnvelope, FaPhoneAlt } from "react-icons/fa";
import "./contact_us.scss";

const ContactUs = () => {
  const navigate = useNavigate();

  const handleStartTour = () => {
    const role = (localStorage.getItem("user_role") || "client").toLowerCase();
    localStorage.removeItem("finlo_tour_completed");
    localStorage.setItem("finlo_tour_step", "1");
    localStorage.setItem("finlo_tour_force_start", "true");
    window.dispatchEvent(new Event("start-portal-tour"));
    navigate(`/finlo/${role}/my_services`);
  };

  return (
    <div className="help-support-page">
      <div className="help-support-grid">
        <section className="help-support-card">
          <h2 className="help-support-card-title">Take Tour</h2>
          <p className="help-support-card-text">
            Explore the portal with a short guided tour and discover key
            features, navigation, and helpful tips.
          </p>
          <button
            type="button"
            className="help-support-tour-btn"
            onClick={handleStartTour}
          >
            Start Tour
          </button>
        </section>

        <section className="help-support-card">
          <h2 className="help-support-card-title">Troubleshoot</h2>
          <p className="help-support-card-text">If you&apos;re experiencing issues:</p>
          <ul className="help-support-list">
            <li>
              <strong>Hard Refresh:</strong> Press Ctrl + Shift + R (Windows) or
              Cmd + Shift + R (Mac) to reload the page.
            </li>
            <li>
              <strong>Sign Out &amp; Sign In:</strong> Log out of the portal and
              sign back in.
            </li>
            <li>
              <strong>Clear Browser Cache:</strong> If the issue persists, clear
              your browser cache and reload the portal.
            </li>
            <li>
              <strong>Still Need Help?</strong> Contact Technical Support (
              <a href="mailto:tech@finlotax.com">tech@finlotax.com</a>).
            </li>
          </ul>
        </section>

        <section className="help-support-card">
          <h2 className="help-support-card-title">Contact Details</h2>
          <ul className="help-support-contact-list">
            <li>
              <span className="help-support-contact-icon" aria-hidden="true">
                <FaMapMarkerAlt />
              </span>
              <span>
              1190 Miraloma Way Ste P
                <br />
                Sunnyvale, CA 94085
              </span>
            </li>
            <li>
              <span className="help-support-contact-icon" aria-hidden="true">
                <FaClock />
              </span>
              <span>Mon - fri, 9:00 AM - 6:00 PM EST</span>
            </li>
            <li>
              <span className="help-support-contact-icon" aria-hidden="true">
                <FaEnvelope />
              </span>
              <a href="mailto:support@finlotax.com">support@finlotax.com</a>
            </li>
            <li>
              <span className="help-support-contact-icon" aria-hidden="true">
                <FaEnvelope />
              </span>
              <a href="mailto:tech@finlotax.com">tech@finlotax.com</a>
            </li>
            <li>
              <span className="help-support-contact-icon" aria-hidden="true">
                <FaPhoneAlt />
              </span>
              <a href="tel:+14088229406">(408) 822-9406</a>
            </li>
          </ul>
        </section>
      </div>
    </div>
  );
};

export default ContactUs;
